import { IconDoor, IconMapPin } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { ProjectLocationCaptureBlock as RenderProjectLocationCaptureBlock } from '../../templateRenderer/CaptureBlocks/ProjectLocationCaptureBlock'
import { ProjectLocationDisplayBlock as RenderProjectLocationDisplayBlock } from '../../templateRenderer/DisplayBlocks/ProjectLocationDisplayBlock'
import {
  ProjectLocationCaptureBlock,
  ProjectLocationDisplayBlock,
} from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  SwitchField,
  TypeOption,
} from './_BaseBlockConfig'

import { ProjectLocationFormDropdownProps } from '@/components/form-components/dropdowns/ProjectLocation/ProjectLocationFormDropdown'
import { Tag } from '@/components/shared-components/BUI/Tag'
import {
  getLocationHierarchyTooltip,
  LocationTag,
} from '@/utils/getLocationHierarchy'

export type ProjectLocationCaptureBlockFormValue =
  ProjectLocationFormDropdownProps['value']

class Config extends BaseBlockConfig<ProjectLocationCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'projectLocation' as const

  public override enableBlockToCsvColumn = true
  public override enableBlockToColumnDisplay = true

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Project Location',
    icon: IconMapPin,
    helpText: 'Select a location',
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'searchable',
      label: 'Searchable',
      helpText: 'Whether locations can be searched by typing',
      field: SwitchField,
      default: true,
    },
  ]

  public override mapFormValueToBlock(
    block: ProjectLocationCaptureBlock,
    value: ProjectLocationCaptureBlockFormValue
  ): ProjectLocationCaptureBlock {
    return {
      ...block,
      projectLocationName: value?.projectLocationName ?? null,
      value: value?.id ?? null,
    }
  }

  public override mapBlockToColumnDisplay(
    block: ProjectLocationCaptureBlock
  ): React.ReactNode {
    return <LocationTag location={block.projectLocationName} showIcon />
  }

  public override mapBlockToCsvValue(
    block: ProjectLocationCaptureBlock
  ): string | null {
    return block.value || null
  }

  public override mapBlockToDisplayBlock(
    block: ProjectLocationCaptureBlock
  ): ProjectLocationDisplayBlock {
    const { value, projectLocationName, ...restOfBlock } = block

    return {
      ...restOfBlock,
      value: value || '',
      projectLocationName: projectLocationName || '',
      kind: 'display',
    }
  }

  public override renderBlock(
    block: ProjectLocationCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderProjectLocationCaptureBlock block={block} rules={rules} />
  }

  public override renderDisplayBlock(
    block: ProjectLocationDisplayBlock
  ): React.ReactNode {
    return <RenderProjectLocationDisplayBlock block={block} />
  }
}

export const ProjectLocationCaptureBlockConfig = new Config()
